import { getProduct } from '@itau-loans-www/utils'

const product = getProduct()

const fgts = {
  business: 'pf',
  environment: 'nao-logado',
  business_channel: 'consignado'
}

const consignado = {
  business: 'pf',
  environment: 'nao-logado',
  business_channel: 'consignado'
}

const map = {
  fgts,
  consignado
}

export default map[product] ?? {}
